const selectStyles = {
  option: (provided) => ({
    ...provided
  }),
  control: (provided) => ({
    ...provided,
    background: '#F7F8FD',
    borderRadius: '12px',
    border: 'none',
    minHeight: '48px',
    fontSize: '14px',
    color: '#3C4348',
    width: '100%',
    flex: 1,
    boxShadow: 'none'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#3C4348'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999
  })
};

export const customSelectStyle = {
  control: (provided) => ({
    ...provided,
    background: 'transparent',
    border: 'none',
    minHeight: '24px',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    marginLeft: 0,
    color: '#3C4348',
    fontSize: '14px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#3C4348',
    margin: 0,
    fontSize: '14px',
    minWidth: 0,
    maxWidth: '85%',
  }),
  placeholder: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    color: '#3C4348',
    fontSize: '14px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    maxHeight: '24px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
    svg: {
      fill: '#3C4348',
      width: '16px',
      height: '16px',
    },
  }),
};

export default selectStyles;
